import { DeliveryState } from "../../../type/delivery-state";

interface Action {
  type: string;
  payload: {
    deliveryIds: string[];
  };
}

export const removeControlDeliveriesByIdsDispatch = (
  state: DeliveryState,
  action: Action
) => {
  const { deliveryIds } = action.payload;
  state.controlDeliveries = state.controlDeliveries.filter(
    (controlDelivery) =>
      !deliveryIds.some(
        (deliveryId) => deliveryId === controlDelivery.delivery.id
      )
  );
};
